import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "components/ui/badge";
import { format, isValid, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

import { IRegionalSubstitution } from "@/@types/regional-substitution";
import ActionTable from "../components/action-table";
import { STATUS_COLORS, STATUS_LABELS } from "../constants/status";
import { formatDate } from "@/utils/format-date";

const formatCreatedAt = (value: string): string => {
  const parsed = parseISO(value);
  if (!isValid(parsed)) return "-";
  return format(parsed, "dd/MM/yyyy HH:mm", { locale: ptBR });
};

export const columns: ColumnDef<IRegionalSubstitution>[] = [
  {
    accessorKey: "regional",
    header: "Regional",
    cell: ({ row }) => {
      const regional = row.original.regional;
      return (
        <div className="flex flex-col">
          <span className="font-medium">{regional.name}</span>
          {regional.email && (
            <span className="text-xs text-muted-foreground">
              {regional.email}
            </span>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "user",
    header: "Gerente",
    cell: ({ row }) => {
      const gerente = row.original.user;
      return (
        <div className="flex flex-col">
          <span className="font-medium">{gerente.name}</span>
          <span className="text-xs text-muted-foreground">
            {gerente.email}
          </span>
        </div>
      );
    },
  },
  {
    accessorKey: "initial_term",
    header: "Início",
    cell: ({ row }) => formatDate(row.getValue("initial_term")),
  },
  {
    accessorKey: "final_term",
    header: "Fim",
    cell: ({ row }) => formatDate(row.getValue("final_term")),
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.original.status;
      return (
        <Badge className={STATUS_COLORS[status]}>{STATUS_LABELS[status]}</Badge>
      );
    },
  },
  {
    accessorKey: "created_at",
    header: "Criado em",
    cell: ({ row }) => formatCreatedAt(row.getValue("created_at")),
  },
  {
    id: "actions",
    cell: ({ row }) => <ActionTable row={row.original} />,
  },
];
